module.exports = __webpack_public_path__ + "img/Icon.35538eed.svg";